import { Link } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import version from "../package.json";

export default function Footer() {
  return (
    <>
      <Grid
        item
        sx={{
          justifyContent: "flex-start",
          color: "white",
          paddingTop: "0.5em",
          paddingLeft: "0.5em",
        }}
      >
        Version: {version.version} (02 September 2026) | Environment: production | ©{" "}
        <Box
          component="a"
          href="https://www.claimscon.org/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: "white",
            textDecoration: "underline",
            "&:hover": {
              color: "blue",
            },
          }}
        >
          Claims Conference
        </Box>{" "}
        All Rights Reserved | Best viewed on Google Chrome
      </Grid>
      <Grid item sx={{ alignItems: "flex-end" }}>
        <Link to="/">
          <img src={"/cclogo.svg"} alt="logo" width={200} height={45} />
        </Link>
      </Grid>
    </>
  );
}
